import React from "react";
import { Link } from "react-router-dom";
import "./Householdheader.css";

export default function Householdheader() {
  const base = process.env.PUBLIC_URL;

  return (
    <section
      className="hh-hero"
      role="banner"
      aria-label="Household Junk Removal hero banner"
    >
      {/* Background image */}
      <img
        className="hh-hero__bg"
        src={`${base}/(232).webp`}
        alt="Household junk removal team at work"
        loading="eager"
      />

      {/* Gradient/dimming overlay */}
      <div className="hh-hero__overlay" aria-hidden="true" />

      {/* Centered content */}
      <div className="hh-hero__content">
        <nav className="hh-hero__breadcrumb" aria-label="Breadcrumb">
          <Link to="/" className="hh-hero__breadcrumb-link">Home</Link>
          <span className="hh-hero__breadcrumb-sep" aria-hidden="true">›</span>
          <span className="hh-hero__breadcrumb-current">Household Junk Removal</span>
        </nav>

        <h1 className="hh-hero__title">Household Junk Removal</h1>
        <p className="hh-hero__subtitle">
          Community-driven junk removal committed to a greener tomorrow.
        </p>
      </div>

      {/* Premium depth touches */}
      <div className="hh-hero__vignette" aria-hidden="true" />
      <div className="hh-hero__grain" aria-hidden="true" />
    </section>
  );
}
